import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { bindAll } from '@bibliocommons/utils-react';
import { TextButton } from '@bibliocommons/deprecated-base-buttons';
import { Search as SearchIcon, Cross as CrossIcon } from '@bibliocommons/deprecated-base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import './NewSearchButton.scss';

const renderExpanded = () => (
  <div>
    <CrossIcon />
    <ScreenReaderMessage>
      <FormattedMessage id="close_search_form" />
    </ScreenReaderMessage>
  </div>
);

const renderCollapsed = () => (
  <div>
    <SearchIcon /> <FormattedMessage id="new_search" />
  </div>
);

export default class NewSearchButton extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleClick() {
    const { expanded, handleExpand, handleCollapse } = this.props;
    return expanded ? handleCollapse() : handleExpand();
  }

  render() {
    return (
      <TextButton handleClick={this.handleClick} className="cp-new-search-button">
        {this.props.expanded ? renderExpanded() : renderCollapsed()}
      </TextButton>
    );
  }
}

NewSearchButton.propTypes = {
  expanded: PropTypes.bool.isRequired,
  handleExpand: PropTypes.func.isRequired,
  handleCollapse: PropTypes.func.isRequired
};
